// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"3e5e68db","725":"a1b56089"}[chunkId] + ".chunk.css";
};